import { useQuery, useMutation } from "@tanstack/react-query";
import { fetchAllBankPayTps } from "services/bankpaytp";

export const useAllBankPayTps = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-bank-pay-tps", filters],
    queryFn: () => fetchAllBankPayTps(filters),
  });
  return query;
};
